export const ADD_BANNER = 'ADD_BANNER';
export const GET_BANNERS = 'GET_BANNERS';
export const SET_BANNER = 'SET_BANNER';
export const SET_BANNERS = 'SET_BANNERS';
export const EDIT_BANNER = 'EDIT_BANNER';
export const REMOVE_BANNER = 'REMOVE_BANNER';
export const DELETE_BANNER = 'DELETE_BANNER';
export const STORE_BANNER = 'STORE_BANNER';
export const REPRIORITIZE_BANNERS = 'REPRIORITIZE_BANNERS';
